import { useState, useEffect, useCallback } from "react";
import servicesService from "../../../api/servicesService";
import { getBusinessDateParts } from "../../../utils/dateUtils";
import { normalizeCalendarEvents } from "../utils";

const businessNowDate = () => {
  const { year, month, day } = getBusinessDateParts();
  return new Date(year, month, day);
};

/**
 * Hook personalizado para manejar la lógica del calendario
 */
export const useCalendar = (initialDate = businessNowDate()) => {
  const [currentDate, setCurrentDate] = useState(initialDate);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadEvents = useCallback(async () => {
    try {
      setLoading(true);
      const month = currentDate.getMonth() + 1;
      const year = currentDate.getFullYear();
      const res = await servicesService.getCalendar(month, year);
      const normalized = normalizeCalendarEvents(res.data.data || []);
      setEvents(normalized);
    } catch (err) {
      console.error("Error loading calendar events:", err);
      setEvents([]);
    } finally {
      setLoading(false);
    }
  }, [currentDate]);

  useEffect(() => {
    loadEvents();
  }, [loadEvents]);

  const changeMonth = useCallback((direction) => {
    const newDate = new Date(currentDate);
    // Establecer el día 1 para evitar problemas de overflow de fechas
    // (ej: 31 de enero -> febrero salta a marzo porque febrero no tiene 31 días)
    newDate.setDate(1);
    newDate.setMonth(currentDate.getMonth() + direction);
    setEvents([]);
    setLoading(true);
    setCurrentDate(newDate);
  }, [currentDate]);

  const refreshEvents = useCallback(() => {
    loadEvents();
  }, [loadEvents]);

  return {
    currentDate,
    events,
    loading,
    changeMonth,
    refreshEvents,
    setCurrentDate,
  };
};

